import { useMutation } from "react-query";
import actionService from "../../services/actionService";

const useSaveAction = () => useMutation(actionService.update, {});

export default useSaveAction;
